import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PivotTableRow from './PivotTableRow';


const useStyles = makeStyles({
  table: {
    '& .MuiTableBody-root .MuiTableCell-root': {
      fontSize: '12px',
    },
    '& .MuiTableCell-head': {
      fontWeight: 'bold',
      '&:first-child': {
        paddingLeft: '8px',
        width: '150px'
      }
    }
  }
});

const columns = [
  {label: 'Year', propertyName: 'year'},
  {label: 'Sales', propertyName: 'current_year_week_revenue'},
  {label: 'Sales Last Year', propertyName: 'last_year_week_revenue'},
  {label: 'Sales YoY', propertyName: 'year_over_year_change'},
  {label: 'Sales PW', propertyName: 'previous_week_revenue'},
  {label: 'Sales WoW', propertyName: 'week_over_week_change'}
];

type PivotTableProps = {
  groupedData: {
    [year: string]: {
      [quarter: string]: {
        [month: string]: {
          [week: string]: [ISalesAnnualComparisonByWeek]
        }
      }
    }
  };
};

const PivotTable: React.FC<PivotTableProps> = (props) => {
  const { groupedData } = props;
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="collapsible table">
        <TableHead>
          <TableRow>
            {columns.map(({label, propertyName}) => (
              <TableCell key={propertyName}>{label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(groupedData)?.map((year, index) => (
            <PivotTableRow key={`${year}-${index}`} row={groupedData[year]} heading={year} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PivotTable;
